<template>
    <div class="main-container">
        <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
            <b-spinner
                variant="dark"
                label="Spinning"
                class="login-loader"
            ></b-spinner>
        </div>

        <div class="input-group search-bar">
            <b-form-input v-model="search_text" :placeholder="$t('text.search')"></b-form-input>
            <button 
                v-if="search_text"
                type="button"
                class="btn clear-search-button"
                @click="search_text=''">
                ╳
            </button>
        </div>

        <table v-if="isSmallScreen">
            <tr>
                <th @click="setOrderBy('name')">{{ $t('text.name') }}</th>
                <th @click="setOrderBy('cabin')">{{ $t('text.cabin') }}</th>
            </tr>
            <tr class="info-row" v-for="cabin_price in cabin_prices" :key="cabin_price.id" @click="cabinPriceClicked(cabin_price)">
                <td>{{ cabin_price.name }}</td>
                <td>{{ cabin_price.getCabinString() }}</td>
            </tr>
        </table>

        <table v-if="!isSmallScreen">
            <tr>
                <th @click="setOrderBy('name')">{{ $t('text.name') }}</th>
                <th @click="setOrderBy('cabin')">{{ $t('text.cabin') }}</th>
                <th @click="setOrderBy('weeks')">{{ $t('text.weeks') }}</th>
            </tr>
            <tr class="info-row" v-for="cabin_price in cabin_prices" :key="cabin_price.id" @click="cabinPriceClicked(cabin_price)">
                <td>{{ cabin_price.name }}</td>
                <td>{{ cabin_price.getCabinString() }}</td>
                <td>{{ cabin_price.getCleanedWeekString() }}</td>
            </tr>
        </table>

        <b-row>
            <b-col></b-col>
            <b-col>
                <b-pagination
                    v-if="rows > 10"
                    style="text-align:center;width:100%;margin-top:16px;"
                    align="center"
                    v-model="current_page"
                    :total-rows="rows"
                    :per-page="per_page"
                    aria-controls="my-table"
                ></b-pagination>
            </b-col>
            
            <b-col>
                <b-button 
                href="/cabin-price/" 
                class="add-button"
                variant="primary"
                >Lägg till</b-button>
            </b-col>
        </b-row>
        
        

        
    </div>
</template>

<script>
import CabinApiService from "../../services/cabin_api_service";
import CabinPrice from "../../models/cabin_price";

export default {
    name: "PriceAdminComponent",
    data() {
        return {
            loading: false,
            cabin_prices: [],
            order_by: 'name',
            search_text: '',
            has_made_initial_call: false,
            per_page: 10,
            current_page: 1,
            rows: 0,
            windowWidth : window.innerWidth
        };
    },
    watch: {
        current_page: function() {
            if (this.has_made_initial_call) {
                this.fetchCabinPrices(true);
            }
            if (this.$route.query.current_page != this.current_page && this.isOnCorrectTab) {
                this.$router.push({path: "/admin/prices", query: { current_page: this.current_page, order_by: this.order_by, search_text: this.search_text }});
            }
        },  
        order_by: function() {
            if (this.has_made_initial_call) {
                this.current_page = 1;
                this.fetchCabinPrices(false);
            }
            if (this.$route.query.order_by != this.order_by && this.isOnCorrectTab) {
                this.$router.push({path: "/admin/prices", query: { current_page: this.current_page, order_by: this.order_by, search_text: this.search_text }});
            }
        },
        search_text: function() {
            if (this.has_made_initial_call) {
                this.current_page = 1;
                this.fetchCabinPrices(false);
            }
            if (this.$route.query.search_text != this.search_text && this.isOnCorrectTab) {
                this.$router.push({path: "/admin/prices", query: { current_page: this.current_page, order_by: this.order_by, search_text: this.search_text }});
            }
        },
    },
    computed: {
        isSmallScreen() {
            return this.windowWidth < 980;
        },
        isOnCorrectTab() {
            return this.$route.fullPath.includes('prices')
        }
    },
    methods: {
        async fetchCabinPrices(showLoader) {
            if (showLoader) {
                this.loading = true;
            }
            
            var params = "order_by=" + this.order_by
            if (this.search_text) {
                params += "&search=" + this.search_text.replaceAll("&", "").replaceAll("?", "")
            }
            try {
                const data = await CabinApiService.get_cabin_prices(this.current_page, params);
                if (!this.has_made_initial_call) {
                    this.has_made_initial_call = true;
                }
                this.rows = data.data.count
                this.cabin_prices = data.data.results.map(dict => {
                    return new CabinPrice(dict);
                });
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        setOrderBy(string) {
            if (string == this.order_by) {
                this.order_by = string.includes('-') ? string : '-'+string
            } else {
                this.order_by = string
            }
        },
        cabinPriceClicked(cabin_price) {
            this.$router.push('/cabin-price/' + cabin_price.id); 
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    created() {
        this.has_made_initial_call = false;
        if (this.$route.query.current_page && this.isOnCorrectTab) {
            this.current_page = this.$route.query.current_page;
        }

        if (this.$route.query.order_by && this.isOnCorrectTab) {
            this.order_by = this.$route.query.order_by;
        }

        if (this.$route.query.search_text && this.isOnCorrectTab) {
            this.search_text = this.$route.query.search_text;
        }
        this.fetchCabinPrices(true);
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
    }
};
</script>

<style scoped>
.main-container {
    overflow: visible;
    background-color: transparent;
    padding-bottom: 40px;
}

table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    border-radius: 8px;
    color: #495057;
    table-layout: fixed;
}

td, th {
    text-align: center;
    padding: 8px;
    height:80px;
    white-space: nowrap;
    overflow:hidden;
}

th:hover {
    background-color: #cee4ff;
    cursor: pointer;
}

tr:nth-child(even) {
    background-color: #e7f2ff;
}

.info-row:hover {
    background-color: #cee4ff;
    cursor: pointer;
}

.search-bar {
    margin-top: 40px;
    margin-bottom: 20px;
}

.clear-search-button {
    margin-left: -40px;
    z-index: 100;
    color: #000;    
}

.add-button {
    float: right;
    margin-top: 16px;
}
</style>
